/**
 * Footer Component
 * Site footer with links and copyright
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'About', url: 'https://rapidfusion.co.uk/pages/about', external: true },
    { label: 'Contact', url: 'https://rapidfusion.co.uk/pages/contact', external: true },
  ];

  return (
    <footer className="rf-footer">
      <div className="rf-container">
        <div className="rf-footer-content">
          <Link to="/" className="rf-footer-logo">
            Rapid Fusion
          </Link>

          <ul className="rf-footer-links">
            {footerLinks.map((link, index) => (
              <li key={index}>
                {link.external ? (
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link to={link.url}>{link.label}</Link>
                )}
              </li>
            ))}
          </ul>

          <p className="rf-footer-copyright">
            &copy; {currentYear} Rapid Fusion. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
